import React from 'react';
import './Logo.css';

const Logo = ({ size = 'medium', showText = true }) => {
  return (
    <div className={`logo-container logo-${size}`}>
      <svg
        className="logo-svg"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Graphyra"
      >
        <circle
          cx="25"
          cy="25"
          r="21"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
        />
        <path
          d="M34 18 A12 12 0 1 0 34 32 H28 V26 H33"
          fill="none"
          stroke="currentColor"
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      
      {showText && (
        <span className="logo-text">GRAPHYRA</span>
      )}
    </div>
  );
};

export default Logo;
